// extracted by mini-css-extract-plugin
export default {"container":"PurchaseSuccess_container__a2J7H","button":"PurchaseSuccess_button__+rZBz"};